import { Inject, Injectable } from '@angular/core';
import { APP_STORE_CONFIG_TOKEN, AppFeaturesConfig, APPLICATION_NAME_TOKEN, ApplicationName } from '@ddt-web/config';
import { ConfigService } from '@ddt-web/config-layer';
import { AppStoreConfig } from '@ddt-web/data-service';
import { AppFeatures } from '@ddt-web/domain';
import { AssetResolveResponse, PasPortfolioPosition } from '@ddt-web/pas';
import { WweSecurity } from '@ddt-web/wealth-web';
import * as get from 'lodash/get';

import { PasCorrelationMatrixDataLoaderService } from '../pas-correlation-matrix-data-loader.service';
import { PasRiskProxyDataLoaderService } from '../pas-risk-proxy-data-loader.service';
import { PasPostProcessingService } from './pas-post-processing.service';

/**
 * Service that processes the PAS proxy and correlation matrix for asset-resolve API response for Nile.
 * This is the default behaviour used via PasDataLoaderService.
 */
@Injectable()
export class PasProxyProcessingService extends PasPostProcessingService {
	private appFeatures: Map<string, AppFeatures>;

	constructor(
		protected configService: ConfigService,
		private correlationMatrixDataLoader: PasCorrelationMatrixDataLoaderService,
		private riskProxyService: PasRiskProxyDataLoaderService,
		@Inject(APPLICATION_NAME_TOKEN) protected applicationName: ApplicationName,
		@Inject(APP_STORE_CONFIG_TOKEN) public storeConfig: AppStoreConfig
	) {
		super();
		this.appFeatures = AppFeaturesConfig.APP_FEATURES;
	}
	// wdsDecom: TO BE UPDATED
	public process(portfoliosToLoad: PasPortfolioPosition[], filteredIds?: string[], positionDataFromApiCall?: AssetResolveResponse): void {
		// Trigger api calls for risk proxies
		if (this.appFeatures.get(this.applicationName)?.riskProxy) {
			const apiSecurities: WweSecurity[] = Array.from(get(positionDataFromApiCall, 'securities', new Map()).values());
			this.riskProxyService.populateStoreForRiskProxies(filteredIds, apiSecurities);
		}

		// Trigger api calls for correlation matrix
		if (this.appFeatures.get(this.applicationName)?.correlationMatrix) {
			this.correlationMatrixDataLoader.buildAssetIdDataAndPopulateStore(filteredIds, portfoliosToLoad);
		}
	}
}
